module.exports = __webpack_public_path__ + "static/media/ishaanbose.8c31ae91.jpeg";